import React from "react";
import Footer from "../components/Layout/Footer";
import Header from "../components/Layout/Header";
import "./TermsPage.scss";

const TermsPage = () => {
  return (
    <>
      <Header />

      <div className="terms-page-container">
        <h1>Пользовательское соглашение</h1>
        <p>
          Данный документ (далее — «Соглашение») описывает условия использования
          веб-сайта и его сервисов. Продолжая использовать сайт, вы подтверждаете
          своё согласие с данными условиями.
        </p>

        <h2>1. Общие положения</h2>
        <p>
          1.1. Данный сайт находится в управлении [Название Компании].
          <br />
          1.2. Все права на контент и дизайн сайта принадлежат [Название
          Компании], либо её партнёрам и контрагентам, если не указано иначе.
        </p>

        <h2>2. Регистрация и аккаунт</h2>
        <p>
          2.1. Для доступа к некоторым функциям сайта может потребоваться
          регистрация. При регистрации вы соглашаетесь предоставить точную и
          актуальную информацию.  
          2.2. Администрация сайта оставляет за собой право
          ограничивать доступ к сайту или удалять аккаунты, нарушающие правила.
        </p>

        <h2>3. Ответственность сторон</h2>
        <p>
          3.1. Пользователь самостоятельно несёт ответственность за размещаемую
          информацию и за действия, совершённые на сайте.  
          3.2. Администрация сайта не
          несёт ответственности за временные сбои или прекращение работы сайта,
          а также за возможную потерю данных.
        </p>

        <h2>4. Политика конфиденциальности</h2>
        <p>
          4.1. Данные, которые мы собираем, используются только для улучшения
          качества обслуживания пользователей.  
          4.2. Мы не передаём персональную
          информацию третьим лицам без согласия пользователя, за исключением
          случаев, предусмотренных законом.
        </p>

        <h2>5. Изменения в Соглашении</h2>
        <p>
          5.1. Администрация оставляет за собой право менять или дополнять
          настоящее Соглашение в любой момент без предварительного уведомления.
          Изменения вступают в силу с момента их публикации на сайте.
        </p>

        <h2>6. Контакты</h2>
        <p>
          По любым вопросам, касающимся данного Соглашения, обращайтесь по
          адресу: <a href="mailto:info@example.com">info@example.com</a>
        </p>
      </div>

      <Footer />
    </>
  );
};

export default TermsPage;
